// extracted by mini-css-extract-plugin
export var closeButton = "_g8-2";
export var closeButtonIcon = "_g8-3";
export var lightboxContent = "_g8-1";
export var lightboxOverlay = "_g8-0";